/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { brandMenuMenuIdRePublishPut } from '../fn/publish-configurations/brand-menu-menu-id-re-publish-put';
import { BrandMenuMenuIdRePublishPut$Params } from '../fn/publish-configurations/brand-menu-menu-id-re-publish-put';
import { Empty } from '../models/empty';
import { MenuConfigurationResponse } from '../models/menu-configuration-response';
import { MenuConfigurationsResponse } from '../models/menu-configurations-response';
import { MenuPublishResponse } from '../models/menu-publish-response';
import { menusMenuIdPublishConfigsGet } from '../fn/publish-configurations/menus-menu-id-publish-configs-get';
import { MenusMenuIdPublishConfigsGet$Params } from '../fn/publish-configurations/menus-menu-id-publish-configs-get';
import { menusMenuIdPublishConfigsPost } from '../fn/publish-configurations/menus-menu-id-publish-configs-post';
import { MenusMenuIdPublishConfigsPost$Params } from '../fn/publish-configurations/menus-menu-id-publish-configs-post';
import { menusMenuIdPublishConfigsPut } from '../fn/publish-configurations/menus-menu-id-publish-configs-put';
import { MenusMenuIdPublishConfigsPut$Params } from '../fn/publish-configurations/menus-menu-id-publish-configs-put';
import { publishConfigsGet } from '../fn/publish-configurations/publish-configs-get';
import { PublishConfigsGet$Params } from '../fn/publish-configurations/publish-configs-get';
import { publishConfigsPublishConfigIdDelete } from '../fn/publish-configurations/publish-configs-publish-config-id-delete';
import { PublishConfigsPublishConfigIdDelete$Params } from '../fn/publish-configurations/publish-configs-publish-config-id-delete';
import { publishConfigsPublishConfigIdGet } from '../fn/publish-configurations/publish-configs-publish-config-id-get';
import { PublishConfigsPublishConfigIdGet$Params } from '../fn/publish-configurations/publish-configs-publish-config-id-get';
import { publishConfigurationPublishConfigIdRePublishPut } from '../fn/publish-configurations/publish-configuration-publish-config-id-re-publish-put';
import { PublishConfigurationPublishConfigIdRePublishPut$Params } from '../fn/publish-configurations/publish-configuration-publish-config-id-re-publish-put';
import { publishConfigurationsTypePost } from '../fn/publish-configurations/publish-configurations-type-post';
import { PublishConfigurationsTypePost$Params } from '../fn/publish-configurations/publish-configurations-type-post';

@Injectable({ providedIn: 'root' })
export class PublishConfigurationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `menusMenuIdPublishConfigsGet()` */
  static readonly MenusMenuIdPublishConfigsGetPath = '/menus/{menuId}/publish-configs';

  /**
   * Gets a list of Publish Configurations for a menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusMenuIdPublishConfigsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusMenuIdPublishConfigsGet$Response(params: MenusMenuIdPublishConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
    return menusMenuIdPublishConfigsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of Publish Configurations for a menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusMenuIdPublishConfigsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusMenuIdPublishConfigsGet(params: MenusMenuIdPublishConfigsGet$Params, context?: HttpContext): Observable<MenuPublishResponse> {
    return this.menusMenuIdPublishConfigsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuPublishResponse>): MenuPublishResponse => r.body)
    );
  }

  /** Path part for operation `menusMenuIdPublishConfigsPut()` */
  static readonly MenusMenuIdPublishConfigsPutPath = '/menus/{menuId}/publish-configs';

  /**
   * Updates a menu publish configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusMenuIdPublishConfigsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusMenuIdPublishConfigsPut$Response(params: MenusMenuIdPublishConfigsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
    return menusMenuIdPublishConfigsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a menu publish configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusMenuIdPublishConfigsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusMenuIdPublishConfigsPut(params: MenusMenuIdPublishConfigsPut$Params, context?: HttpContext): Observable<MenuPublishResponse> {
    return this.menusMenuIdPublishConfigsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuPublishResponse>): MenuPublishResponse => r.body)
    );
  }

  /** Path part for operation `menusMenuIdPublishConfigsPost()` */
  static readonly MenusMenuIdPublishConfigsPostPath = '/menus/{menuId}/publish-configs';

  /**
   * Create a menu publish configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusMenuIdPublishConfigsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusMenuIdPublishConfigsPost$Response(params: MenusMenuIdPublishConfigsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
    return menusMenuIdPublishConfigsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a menu publish configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusMenuIdPublishConfigsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusMenuIdPublishConfigsPost(params: MenusMenuIdPublishConfigsPost$Params, context?: HttpContext): Observable<MenuPublishResponse> {
    return this.menusMenuIdPublishConfigsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuPublishResponse>): MenuPublishResponse => r.body)
    );
  }

  /** Path part for operation `publishConfigsPublishConfigIdGet()` */
  static readonly PublishConfigsPublishConfigIdGetPath = '/publish-configs/{publishConfigId}';

  /**
   * Gets a publish Configuration by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishConfigsPublishConfigIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsPublishConfigIdGet$Response(params: PublishConfigsPublishConfigIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationResponse>> {
    return publishConfigsPublishConfigIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a publish Configuration by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishConfigsPublishConfigIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsPublishConfigIdGet(params: PublishConfigsPublishConfigIdGet$Params, context?: HttpContext): Observable<MenuConfigurationResponse> {
    return this.publishConfigsPublishConfigIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuConfigurationResponse>): MenuConfigurationResponse => r.body)
    );
  }

  /** Path part for operation `publishConfigsPublishConfigIdDelete()` */
  static readonly PublishConfigsPublishConfigIdDeletePath = '/publish-configs/{publishConfigId}';

  /**
   * Delete a specified publishConfig by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishConfigsPublishConfigIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsPublishConfigIdDelete$Response(params: PublishConfigsPublishConfigIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return publishConfigsPublishConfigIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a specified publishConfig by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishConfigsPublishConfigIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsPublishConfigIdDelete(params: PublishConfigsPublishConfigIdDelete$Params, context?: HttpContext): Observable<Empty> {
    return this.publishConfigsPublishConfigIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `publishConfigurationsTypePost()` */
  static readonly PublishConfigurationsTypePostPath = '/publish-configurations/{type}';

  /**
   * POST Publish Configurations for brand menu or store menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishConfigurationsTypePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigurationsTypePost$Response(params: PublishConfigurationsTypePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationsResponse>> {
    return publishConfigurationsTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * POST Publish Configurations for brand menu or store menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishConfigurationsTypePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigurationsTypePost(params: PublishConfigurationsTypePost$Params, context?: HttpContext): Observable<MenuConfigurationsResponse> {
    return this.publishConfigurationsTypePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuConfigurationsResponse>): MenuConfigurationsResponse => r.body)
    );
  }

  /** Path part for operation `publishConfigurationPublishConfigIdRePublishPut()` */
  static readonly PublishConfigurationPublishConfigIdRePublishPutPath = '/publish-configuration/{publishConfigId}/re-publish';

  /**
   * Republish Brand Hydrated Menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishConfigurationPublishConfigIdRePublishPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigurationPublishConfigIdRePublishPut$Response(params: PublishConfigurationPublishConfigIdRePublishPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return publishConfigurationPublishConfigIdRePublishPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Republish Brand Hydrated Menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishConfigurationPublishConfigIdRePublishPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigurationPublishConfigIdRePublishPut(params: PublishConfigurationPublishConfigIdRePublishPut$Params, context?: HttpContext): Observable<void> {
    return this.publishConfigurationPublishConfigIdRePublishPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `brandMenuMenuIdRePublishPut()` */
  static readonly BrandMenuMenuIdRePublishPutPath = '/brand-menu/{menuId}/re-publish';

  /**
   * Republish Brand Hydrated Menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `brandMenuMenuIdRePublishPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  brandMenuMenuIdRePublishPut$Response(params: BrandMenuMenuIdRePublishPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return brandMenuMenuIdRePublishPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Republish Brand Hydrated Menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `brandMenuMenuIdRePublishPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  brandMenuMenuIdRePublishPut(params: BrandMenuMenuIdRePublishPut$Params, context?: HttpContext): Observable<void> {
    return this.brandMenuMenuIdRePublishPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `publishConfigsGet()` */
  static readonly PublishConfigsGetPath = '/publish-configs';

  /**
   * Gets Publish Configurations for all Menus of the Tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishConfigsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsGet$Response(params: PublishConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationsResponse>> {
    return publishConfigsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets Publish Configurations for all Menus of the Tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishConfigsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishConfigsGet(params: PublishConfigsGet$Params, context?: HttpContext): Observable<MenuConfigurationsResponse> {
    return this.publishConfigsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuConfigurationsResponse>): MenuConfigurationsResponse => r.body)
    );
  }

}
